var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector57(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 307,
    viewBox: "0 0 52 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.416 306.764C304.028 287.849 300.322 283.73 285.505 264.321C281.875 259.566 276.163 250.322 270.708 238.905C269.074 235.488 267.591 232.1 266.232 228.759C256.538 204.852 255.17 178.069 257.422 151.618C263.172 84.129 226.64 23.2171 171.329 5.45979C115.923 -12.326 54.3967 16.9342 24.3748 62.5944C20.4688 68.5357 3.23875 96.5715 0.691781 127.331C-7.37678 224.451 86.6994 263.258 229.843 292.642C232.627 293.211 245.885 295.385 248.698 295.774L327.426 306.774L327.416 306.764Z",
    fill: "#1E1E22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector57);
export default __webpack_public_path__ + "static/media/vector5-7.15c7928b26c60fd8ff0250c5c58a6cc2.svg";
export { ForwardRef as ReactComponent };